webpackJsonp([1],{

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SocialCarousel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SocialCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SocialCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slideout__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slideout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slideout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_handorgel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_carousel__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__case_studies__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__case_studies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__case_studies__);






var Rellax = __webpack_require__(70);
var VueScrollTo = __webpack_require__(76);
var inView = __webpack_require__(69);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_carousel___default.a);

window.Vue = __webpack_require__(30);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(VueScrollTo);

var app = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: '#app',

    components: {
        SocialCarousel: __WEBPACK_IMPORTED_MODULE_3__components_SocialCarousel___default.a
    }
});

var rellaxEls = document.getElementsByClassName('rellax');
if (rellaxEls.length) {
    var rellax = new Rellax('.rellax', {
        center: true
    });
}

var rellaxTopEls = document.getElementsByClassName('rellax-top');
if (rellaxTopEls.length) {
    var rellaxTop = new Rellax('.rellax-top', {
        center: false
    });
}

var phantomLinks = document.getElementsByClassName('phantom-link');
__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(phantomLinks).forEach(function (link) {
    console.log(link);
    link.addEventListener('click', function (e) {
        var url = link.dataset.link;
        window.location = url;
        e.preventDefault();
    });
});

function animateValue(el, start, end, duration) {
    var range = parseInt(end) - parseInt(start);
    var current = parseInt(start);
    var increment = parseInt(end) > parseInt(start) ? 1 : -1;
    var stepTime = Math.abs(Math.floor(duration / range));
    var timer = setInterval(function () {
        current += increment;
        el.innerHTML = current;
        if (current == parseInt(end)) {
            clearInterval(timer);
        }
    }, stepTime);
}

var animatedNumberEls = document.getElementsByClassName('animated-number');
__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(animatedNumberEls).forEach(function (el) {
    animateValue(el, el.dataset.start, el.dataset.end, el.dataset.duration);
});

inView.threshold(0.5);
inView('.in-view-slideup-number').on('enter', function (el) {
    if (!el.done) {
        setTimeout(function () {
            el.classList.add('in-view--active');
            var numberEl = el.getElementsByClassName('number')[0];
            setTimeout(function () {
                animateValue(numberEl, el.dataset.start, el.dataset.end, el.dataset.duration);
            }, el.dataset.delay);
        }, el.dataset.indelay);
    }
}).on('exit', function (el) {
    el.done = true;
});

var slideout = new __WEBPACK_IMPORTED_MODULE_4_slideout___default.a({
    'panel': document.getElementById('panel'),
    'menu': document.getElementById('menu'),
    'padding': 256,
    'tolerance': 70,
    'easing': 'cubic-bezier(0.19, 1, 0.22, 1)',
    'duration': 300,
    'side': 'right',
    'touch': false
});

var masthead = document.querySelector('#masthead');
var mobileCloseButton = document.querySelector('#close-mobile-nav');

document.querySelector('#menu-hamburger').addEventListener('click', function () {
    slideout.toggle();
    if (slideout.isOpen()) {
        masthead.classList.add('masthead--slideout');
    } else {
        masthead.classList.remove('masthead--slideout');
    }
});

mobileCloseButton.addEventListener('click', function () {
    slideout.close();
    masthead.classList.remove('masthead--slideout');
});

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(document.querySelectorAll(".mobile-nav__accordion")), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;

        console.log(el);
        new __WEBPACK_IMPORTED_MODULE_5_handorgel__["a" /* default */](el, {
            headerOpenClass: 'mobile-nav__submenu--open',
            headerOpenedClass: 'mobile-nav__submenu--opened'
        });
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally {
    try {
        if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
        }
    } finally {
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

var desktopAccordions = [];
var _iteratorNormalCompletion2 = true;
var _didIteratorError2 = false;
var _iteratorError2 = undefined;

try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(document.querySelectorAll(".primary-nav__accordion")), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _el = _step2.value;

        var accordion = new __WEBPACK_IMPORTED_MODULE_5_handorgel__["a" /* default */](_el, {
            headerOpenClass: 'primary-nav__submenu--open',
            headerOpenedClass: 'primary-nav__submenu--opened'
        });

        desktopAccordions.push(accordion);

        accordion.on('fold:open', function (fold) {
            desktopAccordions.forEach(function (accordion) {
                accordion.folds[0].close();
            });
        });
    }
} catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
} finally {
    try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
        }
    } finally {
        if (_didIteratorError2) {
            throw _iteratorError2;
        }
    }
}

var transparentMashtead = document.querySelector('.masthead--transparent');
if (transparentMashtead) {
    window.addEventListener('scroll', function () {
        if (window.pageYOffset > 200) {
            transparentMashtead.classList.add('masthead--transparent-fill');
        } else {
            transparentMashtead.classList.remove('masthead--transparent-fill');
        }
    });
}

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_carousel__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'socialCarousel',
    components: {
        Carousel: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Carousel"],
        Slide: __WEBPACK_IMPORTED_MODULE_0_vue_carousel__["Slide"]
    },
    props: ['socialPosts'],
    mounted: function mounted() {
        console.log('SOCIAL POSTS', this.socialPosts);
    }
});

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

document.addEventListener('DOMContentLoaded', function () {

    if (document.getElementById('case-study-select')) {
        var select = document.getElementById('case-study-select');

        select.addEventListener('change', function (e) {
            console.log(e.target.value);
            window.location.href = '' + window.location.origin + e.target.value;
        });
    };

    if (document.getElementById('load-more')) {
        var load = document.getElementById('load-more');
        var more = document.getElementById('more');

        load.addEventListener('click', function (e) {
            console.log('clicking');
            load.classList.add('case-study__hide');
            more.classList.remove('case-study__hide');
        });
    };
});

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(74)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 75:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('carousel', {
    attrs: {
      "perPageCustom": [
        [0, 1],
        [768, 2],
        [1024, 3]
      ]
    }
  }, _vm._l((_vm.socialPosts), function(post) {
    return _c('slide', [_c('div', {
      staticClass: "col-medium-1-1 social-card__container"
    }, [_c('a', {
      staticClass: "social-card",
      attrs: {
        "target": "_blank",
        "href": post.url
      }
    }, [_c('div', {
      staticClass: "social-card__media",
      style: ({
        backgroundImage: ("url(" + (post.thumb) + ")")
      })
    }, [_c('div', {
      staticClass: "social-card__media-overlay",
      style: ({
        backgroundImage: ("url(" + (post.overlay) + ")")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "social-card__media-gradient"
    })]), _vm._v(" "), _c('div', {
      staticClass: "social-card__main"
    }, [_c('h4', {
      staticClass: "social-card__title",
      domProps: {
        "innerHTML": _vm._s(post.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "social-card__content",
      domProps: {
        "innerHTML": _vm._s(post.excerpt)
      }
    })])])])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32);
module.exports = __webpack_require__(33);


/***/ })

},[78]);


// WEBPACK FOOTER //
// js/app.js